import React, {useState} from "react";
import {useTranslation} from "react-i18next";
//@ts-ignore
import _ from "lodash";

import {Spin} from "antd";
import {LoadingOutlined} from "@ant-design/icons";
import useFetch, {CachePolicies} from "use-http";
import {pathRoutes} from "src/props/util.props";
import {useNavigate} from "react-router-dom"
import CenterConfirmModal from "src/components/shared/Modal/CenterConfirmModal";

function UIModalConfrimDeleteGroup(props: any) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [loading, setLoading]: any = useState(false);

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 24, color: "#FFFFFF" }} spin />
  );

  const deleteGroup = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `/api/v2/groups/${props?.id}`,
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const fnDoneDeleteForever = async () => {
    if (loading === true) return;
    try {
      setLoading(true);
      let res = await deleteGroup.delete();
      props.onClose();
      navigate(pathRoutes.Group);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <CenterConfirmModal
      cancelText={"Cancel"}
      confirmText={<>{loading ? <Spin indicator={antIcon} /> : t("Ok")}</>}
      text={"Are you sure you want to Delete group?"}
      visible={true}
      onCancel={() => {
        if (loading === false) props.onClose();
      }}
      onConfirm={() => {
        fnDoneDeleteForever();
      }}
    ></CenterConfirmModal>

    // <Modal
    //   // centered
    //   visible={true}
    //   className={styles.modalOveride}
    //   onCancel={() => {
    //   }}
    //   closeIcon={<div />}
    //   closable={false}
    // >
    //   <div className={styles.boxCreate}>
    //     <div style={{ fontSize: "1.3rem", fontWeight: "bold" }}>
    //       {t("Delete Group")}
    //     </div>

    //     <div style={{ fontSize: "1rem", color: "#5f5f5f" }}>{t("Are you sure you want to Delete group?")}</div>

    //     <div className={styles.boxConfirmBtn}>
    //       <button
    //         className={styles.bottonBtnCancel}
    //         style={{ fontSize: "1.2rem", marginTop: "39px" }}
    //       >
    //         <div
    //           onClick={() => {
    //             if(loading === false)
    //            props.onClose();
    //           }}
    //         >
    //           {t("Cancel")}
    //         </div>
    //       </button>
    //       <button
    //         className={styles.bottonBtnOk}
    //         style={{ fontSize: "1.2rem", marginTop: "39px" }}
    //       >
    //         <div onClick={fnDoneDeleteForever}>
    //           {loading ? <Spin indicator={antIcon} /> : t("Ok")}
    //         </div>
    //       </button>
    //     </div>
    //   </div>
    // </Modal>
  );
}

export default UIModalConfrimDeleteGroup;
